'use client';

import { trackHeroAction } from '../../lib/analytics';

export default function HeroButtons() {
    return (
        <div className="btn-group">
            <a
                href="#iletisim"
                className="btn btn-primary btn-ripple"
                onClick={() => trackHeroAction('contact')}
            >
                İletişime Geç
            </a>
            <a
                href="https://github.com/victortomaili"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary"
                onClick={() => trackHeroAction('github')}
            >
                GitHub
            </a>
        </div>
    );
}
